var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconSrc)?_c('div',{staticClass:"my-1 mr-2 pull-left my-incident-icon-container"},[_c('img',{staticClass:"my-incident-icon",attrs:{"src":_vm.iconSrc,"alt":"My Incident"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }